export default __webpack_public_path__ + "static/media/team-management.9607046a.png";